<template>
  <div>
    <color-picker
      v-model="isPickerOpened"
      :p-color="pColor"
      :close-on-click-body="true"
      :show-close="false"
      type="linear"
      @changeColor="changeColor"
      @onClose="onClosePicker"
    />
  </div>
</template>

<script>

import ColorPicker from 'vue2-color-picker-gradient';
export default {
  name: 'ColorPickerComponent',
  components: {ColorPicker},
  props: ['model', 'defaultColor', 'type'],
  data() {
    return {
      color: true,
      pColor: {
        hex: '#194d33',
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        color: this.defaultColor || 'rgba(255,255,255,1)',
      },
    };
  },
  computed: {
    isPickerOpened: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value); // Emit the update to parent
      },
    },
  },
  methods: {
    changeColor({ style, colors, deg, color }) {
      this.$emit('color-changed', {type:this.type, color});
      this.pColor = color;
      this.style = `background: ${color.color}`;
    },
    onClosePicker() {
      this.$emit('close-picker', this.type);
    },
  },
};
</script>


<style lang="scss">
.color_picker_wrapper,
.color_picker_wrapper .color_picker_box {
  padding: 0 !important;

}

.color_picker_wrapper {
  top: 120%;
  z-index: 1000;
  right: 0;
  //transform: translateX(-30%);
  //left: 62%;
  position: absolute;
  width: fit-content !important;
}
.color_hd {
  display: none;
}
</style>